require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./international-spad-sensor-workshop-1-12-1-7.json") })
        }
      }, "path---international-spad-sensor-workshop-1-12-1-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---international-spad-sensor-workshop-1-12-1-7!./.cache/json/international-spad-sensor-workshop-1-12-1-7.json
// module id = 469
// module chunks = 231608221292675